"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pulse = exports.GraphMonitor = void 0;
const DisplayPanel_1 = require("../UI/DisplayPanel");
/** Creates canvas graph. */
class GraphMonitor {
    constructor(canvasId, opts) {
        //defaults
        this.HEIGHT = 200;
        this.WIDTH = 600;
        this.LINE_COLOUR = "#22ff22ff";
        this.nDIVX = 10;
        this.init = () => {
            //console.log(this.context);
            this.drawAxis(this.nDIVX);
            this.continueAnimation = true;
            this.animate();
        };
        this.animate = () => {
            const width = this.WIDTH;
            const height = this.HEIGHT;
            const line_w = 0.02;
            const ctx = this.CTX;
            const x = this.x;
            const y = this.GetYatX(x);
            if (this.continueAnimation) {
                requestAnimationFrame(this.animate);
            }
            if (x % width == 0) {
                ctx.beginPath();
                ctx.moveTo(0.5, y + 0.5);
            }
            else if (x % width == width - 1) {
                ctx.closePath();
                ctx.clearRect(0, 0, width, height + 0.5);
            }
            else {
                ctx.lineTo(x % width, y);
                ctx.lineWidth = line_w;
                ctx.strokeStyle = this.LINE_COLOUR;
                ctx.stroke();
            }
            this.x++;
        };
        this.playPause = () => {
            //console.log("pp");
            this.continueAnimation = !this.continueAnimation;
            if (this.continueAnimation) {
                requestAnimationFrame(this.animate);
            }
        };
        this.updatenX = () => {
            this.nX = Number(DisplayPanel_1.nX.value);
            this.X = -1;
            //console.log(nX);
        };
        this.GetYatX = (x) => { return this.GETY(x); };
        this.Label = (s, x, y, size) => {
            const ctx = this.CTX;
            ctx.font = typeof size !== 'undefined' ? size + "px Arial" : "9px Arial";
            ctx.fillStyle = "white";
            ctx.fillText(s, x, y);
        };
        this.CANVAS_ID = canvasId;
        this.HEIGHT = (opts === null || opts === void 0 ? void 0 : opts.HEIGHT) ? opts.HEIGHT : this.HEIGHT;
        this.WIDTH = (opts === null || opts === void 0 ? void 0 : opts.WIDTH) ? opts.WIDTH : this.WIDTH;
        this.LINE_COLOUR = (opts === null || opts === void 0 ? void 0 : opts.LINE_COLOUR) ? opts.LINE_COLOUR : this.LINE_COLOUR;
        this.GETY = (opts === null || opts === void 0 ? void 0 : opts.GETY) ? opts === null || opts === void 0 ? void 0 : opts.GETY : Pulse;
        this.nDIVX = (opts === null || opts === void 0 ? void 0 : opts.nDIVX) ? Number(opts === null || opts === void 0 ? void 0 : opts.nDIVX) : Number(DisplayPanel_1.nX.value);
        let canvas = document.getElementById(this.CANVAS_ID);
        let ctx = canvas.getContext("2d");
        this.CANVAS = canvas;
        this.CTX = ctx;
        this.x = -1;
        this.continueAnimation = false;
        canvas.width = this.WIDTH;
        canvas.height = this.HEIGHT + 10; // for xaxis
        canvas.setAttribute("style", "width:" + this.WIDTH + "px; " + "height:" + this.HEIGHT + "px");
        window.addEventListener('playpause', this.playPause);
        DisplayPanel_1.nX.addEventListener("change", this.updatenX);
        this.init();
    }
    drawAxis(numDivX = 10) {
        let ctx = this.CTX, w = this.WIDTH, h = this.HEIGHT, canvh = this.CANVAS.height;
        let dx = w / numDivX;
        //console.log(w,numDivX,dx);
        ctx.clearRect(0, 0, w, canvh);
        ctx.moveTo(0.5, canvh + 0.5);
        ctx.strokeStyle = "#ffffff";
        // ticks
        for (let x = 0; x <= numDivX; x++) {
            ctx.beginPath();
            ctx.lineWidth = 1;
            ctx.moveTo(x * dx, canvh - 5);
            ctx.lineTo(x * dx, canvh);
            ctx.stroke();
            ctx.closePath();
        }
        ctx.moveTo(-1, h / 2);
    }
    get X() { return this.x; }
    set X(x) { this.x = x; }
    set Y(fn) { this.GETY = fn; }
    set nX(n) { this.nDIVX = n; this.drawAxis(n); }
}
exports.GraphMonitor = GraphMonitor;
//** GRAPHING Helper Fns ****************************************************//
function Pulse(t, x, a, w) {
    return -a * Math.exp(-0.5 * Math.pow((t - x) / w, 2));
}
exports.Pulse = Pulse;
